/**
 * Главный модуль приложения React.
 * @module src-module
 */
import "./index.scss";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import App from "./App.js";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store.js";
import ErrorBoundary from "./components/errorBoundary/ErrorBoundary.jsx";
import { ConfigService } from "../personal-studio-components/service/ConfigService.js";
import { Config } from "../personal-studio-components/service/Config.js";
const Root = () => {
  const [appRoot, setAppRoot] = useState(null);
  const [mentorChatApiRoot, setMentorChatApiRoot] = useState(null);
  const [signUpVideoGuide, setSignUpVideoGuide] = useState(null);
  const [notificationsArchive, setNotificationsArchive] = useState(null);
  useEffect(() => {
    async function getConfig() {
      await Config.load();
      const app_root = Config.get("app_root");
      const mentor_chat_api_root = Config.get("mentor_chat_api_root");
      const sign_up_video_guide = Config.get("sign_up_video_guide");
      const notifications_archive = Config.get("notifications_archive");
      setAppRoot(app_root);
      setSignUpVideoGuide(sign_up_video_guide);
      setMentorChatApiRoot(mentor_chat_api_root);
      setNotificationsArchive(notifications_archive);
    }
    getConfig();
  }, []);

  if (typeof appRoot == "string")
    return (
      <BrowserRouter basename={appRoot}>
        <Provider store={store}>
          <ErrorBoundary>
            <App
              appRoot={appRoot}
              mentorChatApiRoot={mentorChatApiRoot}
              signUpVideoGuide={signUpVideoGuide}
              notificationsArchive={notificationsArchive}
            />
          </ErrorBoundary>
        </Provider>
      </BrowserRouter>
    );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);
